module.exports = __webpack_public_path__ + "img/visa2.40a24129.png";